import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { LoadingSpinner } from './components/shared/LoadingSpinner';
import { NowHomePage } from './pages/NowHomePage';
const CategoryPage = lazy(() => import('./pages/CategoryPage').then(module => ({
  default: module.CategoryPage
})));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage').then(module => ({
  default: module.CategoriesPage
})));
const CartPage = lazy(() => import('./pages/CartPage').then(module => ({
  default: module.CartPage
})));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage').then(module => ({
  default: module.CheckoutPage
})));
const AccountPage = lazy(() => import('./pages/AccountPage').then(module => ({
  default: module.AccountPage
})));
const OffersPage = lazy(() => import('./pages/OffersPage').then(module => ({
  default: module.OffersPage
})));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage').then(module => ({
  default: module.ProductDetailPage
})));
const PrescriptionPage = lazy(() => import('./pages/PrescriptionPage').then(module => ({
  default: module.PrescriptionPage
})));
const AllPrescriptionsPage = lazy(() => import('./pages/AllPrescriptionsPage').then(module => ({
  default: module.AllPrescriptionsPage
})));
const BMICalculatorPage = lazy(() => import('./pages/BMICalculatorPage').then(module => ({
  default: module.BMICalculatorPage
})));
const NutritionCalculatorPage = lazy(() => import('./pages/NutritionCalculatorPage').then(module => ({
  default: module.NutritionCalculatorPage
})));
const IngredientGlossaryPage = lazy(() => import('./pages/IngredientGlossaryPage').then(module => ({
  default: module.IngredientGlossaryPage
})));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage').then(module => ({
  default: module.ThankYouPage
})));
const StoreLocatorPage = lazy(() => import('./pages/StoreLocatorPage').then(module => ({
  default: module.StoreLocatorPage
})));
const BrandsPage = lazy(() => import('./pages/BrandsPage').then(module => ({
  default: module.BrandsPage
})));
const BrandStorePage = lazy(() => import('./pages/BrandStorePage').then(module => ({
  default: module.BrandStorePage
})));
const ContactUs = lazy(() => import('./pages/ContactUs').then(module => ({
  default: module.ContactUs
})));
const AboutUs = lazy(() => import('./pages/AboutUs').then(module => ({
  default: module.AboutUs
})));
const FAQPage = lazy(() => import('./pages/FAQPage').then(module => ({
  default: module.FAQPage
})));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage').then(module => ({
  default: module.PrivacyPolicyPage
})));
const TermsConditionsPage = lazy(() => import('./pages/TermsConditionsPage').then(module => ({
  default: module.TermsConditionsPage
})));
const ReturnPolicyPage = lazy(() => import('./pages/ReturnPolicyPage').then(module => ({
  default: module.ReturnPolicyPage
})));
const ShippingPolicyPage = lazy(() => import('./pages/ShippingPolicyPage').then(module => ({
  default: module.ShippingPolicyPage
})));
const ReportIssuePage = lazy(() => import('./pages/ReportIssuePage').then(module => ({
  default: module.ReportIssuePage
})));
const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage').then(module => ({
  default: module.HelpCenterPage
})));
const TrackOrderPage = lazy(() => import('./pages/TrackOrderPage').then(module => ({
  default: module.TrackOrderPage
})));
const MedicineReminderPage = lazy(() => import('./pages/MedicineReminderPage').then(module => ({
  default: module.MedicineReminderPage
})));
const BundleBuilderPage = lazy(() => import('./pages/BundleBuilderPage').then(module => ({
  default: module.BundleBuilderPage
})));
const StackingGuidePage = lazy(() => import('./pages/StackingGuidePage').then(module => ({
  default: module.StackingGuidePage
})));
const QuizResultsPage = lazy(() => import('./pages/QuizResultsPage').then(module => ({
  default: module.QuizResultsPage
})));
const PharmacistConsultationPage = lazy(() => import('./pages/PharmacistConsultationPage').then(module => ({
  default: module.PharmacistConsultationPage
})));
const RxHomePage = lazy(() => import('./pages/RxHomePage').then(module => ({
  default: module.RxHomePage
})));
const NowStorePage = lazy(() => import('./pages/NowStorePage').then(module => ({
  default: module.NowStorePage
})));
const MobileMenuPage = lazy(() => import('./pages/MobileMenuPage').then(module => ({
  default: module.MobileMenuPage
})));
export function AppRouter() {
  return <>
      <style data-id="element-0" data-mp="yvbz4r3zo1vk">{`:root { --header-height-desktop: 162px !important; }`}</style>
      <BrowserRouter data-id="element-1" data-mp="yxgdy43felam">
        <ScrollToTop data-id="element-2" data-mp="13tx0ituz8rll" />
        <Suspense fallback={<LoadingSpinner data-id="element-4" data-mp="13uyh1duri6ap" />} data-id="element-3" data-mp="13tdm3n4jclcb">
          <Routes data-id="element-5" data-mp="13w01ua1ky75m">
            <Route path="/" element={<NowHomePage data-id="element-7" data-mp="2t8v60rjwswtj" />} data-id="element-6" data-mp="2t9cxlavmmmv4" />
            <Route path="/menu" element={<MobileMenuPage data-id="element-9" data-mp="2t7ac945f5hwq" />} data-id="element-8" data-mp="2t9msncvj3k7o" />
            <Route path="/categories" element={<CategoriesPage data-id="element-11" data-mp="2y7o9rs9e99gi" />} data-id="element-10" data-mp="2y8g3syncez4o" />
            <Route path="/category/:categoryName" element={<CategoryPage data-id="element-13" data-mp="mlw1iz4vukos" />} data-id="element-12" data-mp="mkuhi55w2nux" />
            <Route path="/brands" element={<BrandsPage data-id="element-15" data-mp="hm1cz28ky76w" />} data-id="element-14" data-mp="mirttrs7l6td" />
            <Route path="/brand/:brandSlug" element={<BrandStorePage data-id="element-17" data-mp="hjooe68bgykv" />} data-id="element-16" data-mp="hmswvfsteghc" />
            <Route path="/cart" element={<CartPage data-id="element-19" data-mp="wbpcpz144xsi" />} data-id="element-18" data-mp="wb5x4oyxqlhn" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-21" data-mp="rk7ehiqh5bb8" />} data-id="element-20" data-mp="wbyyfaf4kise" />
            <Route path="/account" element={<AccountPage data-id="element-23" data-mp="rimkpvbzhwef" />} data-id="element-22" data-mp="riw9xgp7fzj2" />
            <Route path="/account/orders" element={<AccountPage data-id="element-25" data-mp="15aawtym8gkve" />} data-id="element-24" data-mp="15bc9u8mt7hfr" />
            <Route path="/account/addresses" element={<AccountPage data-id="element-27" data-mp="11aa5jde1cf6x" />} data-id="element-26" data-mp="159j1mowjsp5n" />
            <Route path="/account/wallet" element={<AccountPage data-id="element-29" data-mp="11c3cyuwh33fz" />} data-id="element-28" data-mp="118z0la8ut1e8" />
            <Route path="/account/points" element={<AccountPage data-id="element-31" data-mp="1f902mt0uueva" />} data-id="element-30" data-mp="1fa1oztnbmnsb" />
            <Route path="/account/wishlist" element={<AccountPage data-id="element-33" data-mp="1aa5mjyu9v4ev" />} data-id="element-32" data-mp="1f75r25bh3z3v" />
            <Route path="/account/returns" element={<AccountPage data-id="element-35" data-mp="3h0v7opslvl4j" />} data-id="element-34" data-mp="1aayn2i2n0xok" />
            <Route path="/account/coupons" element={<AccountPage data-id="element-37" data-mp="3h2zcd9ybwo5v" />} data-id="element-36" data-mp="3h1y0j39hnxn3" />
            <Route path="/account/payment-requests" element={<AccountPage data-id="element-39" data-mp="3c3czj1mex9xl" />} data-id="element-38" data-mp="3c21uyzl57y5f" />
            <Route path="/account/payment-requests/:id" element={<AccountPage data-id="element-41" data-mp="1fzp1h1f3rrou" />} data-id="element-40" data-mp="3c44uqbc3l5nc" />
            <Route path="/offers" element={<OffersPage data-id="element-43" data-mp="1kxqh1cdbl8vk" />} data-id="element-42" data-mp="1g0i3jp349t0n" />
            <Route path="/product/:productId" element={<ProductDetailPage data-id="element-45" data-mp="1kzumhyqvafxy" />} data-id="element-44" data-mp="1kyrwdt1dchj3" />
            <Route path="/prescription" element={<PrescriptionPage data-id="element-47" data-mp="1oyk5c6uocpoz" />} data-id="element-46" data-mp="1oyu0e8uktn1j" />
            <Route path="/prescription/history" element={<AllPrescriptionsPage data-id="element-49" data-mp="1tzhp2nvc1rsl" />} data-id="element-48" data-mp="1p1oihtq4avrs" />
            <Route path="/prescriptions" element={<Navigate to="/prescription/history" replace data-id="element-51" data-mp="1yxrnr8g9naiy" />} data-id="element-50" data-mp="1twbyt5aywjva" />
            <Route path="/rx" element={<RxHomePage data-id="element-53" data-mp="23wcmf3fvdm5a" />} data-id="element-52" data-mp="1yvf6yym8v67h" />
            <Route path="/health" element={<Navigate to="/rx" replace data-id="element-55" data-mp="23urs9exgw57y" />} data-id="element-54" data-mp="23vkp9o6mjgcw" />
            <Route path="/now" element={<NowHomePage data-id="element-57" data-mp="28odv6fdtwuqk" />} data-id="element-56" data-mp="28nkt3rpteter" />
            <Route path="/now/store/:storeSlug" element={<NowStorePage data-id="element-59" data-mp="2cpfwd1rb3gv6" />} data-id="element-58" data-mp="28o4c7br7bnud" />
            <Route path="/rx2" element={<Navigate to="/prescription" replace data-id="element-61" data-mp="2cr0pcmxz2rqx" />} data-id="element-60" data-mp="2cnmppmgp0wn6" />
            <Route path="/doctor-consultation" element={<Navigate to="/rx" replace data-id="element-63" data-mp="2hlwkvx2f3x8s" />} data-id="element-62" data-mp="2hp297a382v3g" />
            <Route path="/pharmacist-consultation" element={<PharmacistConsultationPage data-id="element-65" data-mp="2mndm5totdlpw" />} data-id="element-64" data-mp="2mmatbg7xl97c" />
            <Route path="/bmi-calculator" element={<BMICalculatorPage data-id="element-67" data-mp="2wslsxkky4cdn" />} data-id="element-66" data-mp="2wrk7cm6b07ho" />
            <Route path="/nutrition-calculator" element={<NutritionCalculatorPage data-id="element-69" data-mp="2rqwf5x6c9klv" />} data-id="element-68" data-mp="2rrxs676x0h68" />
            <Route path="/ingredient-glossary" element={<IngredientGlossaryPage data-id="element-71" data-mp="2ms340beiy5ov" />} data-id="element-70" data-mp="2ruak9d6e07x0" />
            <Route path="/thank-you" element={<ThankYouPage data-id="element-73" data-mp="2irj4x2ae4s03" />} data-id="element-72" data-mp="2mt4n935p1yho" />
            <Route path="/store-locator" element={<StoreLocatorPage data-id="element-75" data-mp="2itcfgso4jwdd" />} data-id="element-74" data-mp="2isb1afbtatrf" />
            <Route path="/contact-us" element={<ContactUs data-id="element-77" data-mp="3fg7bn2gnosu7" />} data-id="element-76" data-mp="3fi1w6fo0mixr" />
            <Route path="/about-us" element={<AboutUs data-id="element-79" data-mp="3aip7dpdl31sj" />} data-id="element-78" data-mp="3fjmp60uoltti" />
            <Route path="/faq" element={<FAQPage data-id="element-81" data-mp="3aj7e5fxvgyep" />} data-id="element-80" data-mp="3ajgvkf4upx8s" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-83" data-mp="35qnpnnxnciv4" />} data-id="element-82" data-mp="35rpf4xfet7wd" />
            <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-85" data-mp="31qncs7q74fq6" />} data-id="element-84" data-mp="35pw312m11vgz" />
            <Route path="/return-policy" element={<ReturnPolicyPage data-id="element-87" data-mp="31oauftgj03cl" />} data-id="element-86" data-mp="31pm0y11cvp7e" />
            <Route path="/shipping-policy" element={<ShippingPolicyPage data-id="element-89" data-mp="23x7duj1f50l" />} data-id="element-88" data-mp="22vsfeywhydl" />
            <Route path="/report-issue" element={<ReportIssuePage data-id="element-91" data-mp="3tgi1c268c1ds" />} data-id="element-90" data-mp="3thjoh50isebv" />
            <Route path="/help-center" element={<HelpCenterPage data-id="element-93" data-mp="gzeebv6ikyzp" />} data-id="element-92" data-mp="3tf6zi7wch3pb" />
            <Route path="/track-order" element={<TrackOrderPage data-id="element-95" data-mp="gy387opljf5f" />} data-id="element-94" data-mp="gz62m6m4nzq3" />
            <Route path="/medicine-reminder" element={<MedicineReminderPage data-id="element-97" data-mp="lrz4mmq7otyh" />} data-id="element-96" data-mp="lr62jz276smo" />
            <Route path="/bundle-builder" element={<BundleBuilderPage data-id="element-99" data-mp="732yiv7ptr0i" />} data-id="element-98" data-mp="7208epi7vsln" />
            <Route path="/stacking-guide" element={<StackingGuidePage data-id="element-101" data-mp="c0bfwtl1hr0p" />} data-id="element-100" data-mp="6znkzwtowq17" />
            <Route path="/quiz-results" element={<QuizResultsPage data-id="element-103" data-mp="zqflv7lpa2uv" />} data-id="element-102" data-mp="c1csj2hpelkj" />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>;
}